// src/components/PinisiKata/KalselMapSVG.js
import React from 'react';

// Komponen baru untuk kapal tunda (tugboat)
const Tugboat = ({ scale, duration, pathValues }) => {
    // Palet warna yang sama persis dengan gambar referensi
    const colors = {
        hullRed: '#C0392B',
        deckOrange: '#E59866',
        superstructureCream: '#F5EEF8',
        bumperBlue: '#2C3E50',
        windowBlue: '#5DADE2',
        funnelTan: '#D5BBA9',
        funnelStripe: '#C3A997',
        lifebuoyWhite: '#FFFFFF',
        lifebuoyRed: '#E74C3C',
        ropeBlack: '#212121',
    };

    return (
        <g transform={`scale(${scale})`}>
            {/* Grup ini berisi semua elemen visual kapal */}
            <g transform="translate(0, 30)">
                {/* Lambung Merah Utama */}
                <path d="M 50 200 C 50 250, 320 250, 350 200 L 370 140 L 60 140 Z" fill={colors.hullRed} />
                {/* Bumper Biru di Haluan */}
                <path d="M 55 140 C 30 140, 30 200, 55 200 Z" fill={colors.bumperBlue} />
                <rect x="42" y="155" width="8" height="15" fill="#566573" rx="2" />
                <rect x="42" y="175" width="8" height="15" fill="#566573" rx="2" />
                {/* Dek Oranye */}
                <path d="M 60 140 L 370 140 L 365 130 L 65 130 Z" fill={colors.deckOrange} />
                {/* Detail di lambung */}
                <circle cx="300" cy="155" r="5" fill="#D98880" />
                <circle cx="320" cy="155" r="5" fill="#D98880" />
                <circle cx="340" cy="155" r="5" fill="#D98880" />
                {/* Struktur Kabin (Superstructure) */}
                <path d="M 130 130 L 280 130 L 280 80 L 140 80 C 135 80, 130 85, 130 90 Z" fill={colors.superstructureCream} />
                <rect x="200" y="70" width="80" height="10" fill={colors.deckOrange} />
                <rect x="230" y="60" width="60" height="10" fill={colors.superstructureCream} />
                {/* Jendela Biru */}
                <path d="M 150 115 L 150 95 C 150 90, 170 90, 170 95 L 170 115 Z" fill={colors.windowBlue} />
                {/* Cerobong Asap */}
                <rect x="180" y="20" width="20" height="80" fill={colors.funnelTan} />
                <rect x="175" y="15" width="30" height="5" fill={colors.funnelStripe} rx="2"/>
                <rect x="178" y="70" width="24" height="5" fill={colors.funnelStripe} rx="2"/>
                <rect x="178" y="50" width="24" height="5" fill={colors.funnelStripe} rx="2"/>
                {/* Pagar dan Tali */}
                <g stroke={colors.ropeBlack} strokeWidth="2">
                    <path d="M 70 130 L 70 120 M 365 130 L 365 120" fill="none" />
                    <path d="M 70 120 C 100 140, 120 140, 150 120 C 180 100, 200 100, 230 120 C 260 140, 280 140, 310 120 C 340 100, 350 100, 365 120" fill="none" />
                </g>
                {/* Pelampung (Lifebuoys) */}
                <use href="#lifebuoy" transform="translate(105, 125)" />
                <use href="#lifebuoy" transform="translate(175, 110)" />
                <use href="#lifebuoy" transform="translate(265, 125)" />
                <use href="#lifebuoy" transform="translate(335, 110)" />
                <use href="#lifebuoy" transform="translate(250, 100) scale(0.7)" />
                {/* Tiang Bendera */}
                <g>
                    <rect x="90" y="70" width="4" height="60" fill={colors.bumperBlue} />
                    <rect x="85" y="80" width="25" height="15" fill={colors.hullRed} />
                    <circle cx="92" cy="70" r="4" fill={colors.bumperBlue} />
                </g>
            </g>
            {/* Elemen animasi yang menggerakkan kapal */}
            <animateTransform 
                attributeName="transform" 
                type="translate" 
                values={pathValues} 
                dur={duration} 
                repeatCount="indefinite" 
            />
        </g>
    );
};

function KalselMapSVG({ className }) {
    return (
        <svg viewBox="0 0 800 400" className={className}>
            <defs>
                <linearGradient id="oceanGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#87CEEB', stopOpacity:1}} />
                    <stop offset="50%" style={{stopColor:'#4fc3f7', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#1976d2', stopOpacity:1}} />
                </linearGradient>
                {/* Definisi satu pelampung untuk digunakan kembali oleh semua kapal */}
                <g id="lifebuoy" stroke="#212121" strokeWidth="1.5">
                    <circle cx="0" cy="0" r="12" fill="#FFFFFF" />
                    <path d="M 0 -12 A 12 12 0 0 1 8.5 -8.5 L 6 -6 A 8 8 0 0 0 0 -8 Z" fill="#E74C3C" stroke="none" />
                    <path d="M 12 0 A 12 12 0 0 1 8.5 8.5 L 6 6 A 8 8 0 0 0 8 0 Z" fill="#E74C3C" stroke="none" />
                    <path d="M 0 12 A 12 12 0 0 1 -8.5 8.5 L -6 6 A 8 8 0 0 0 0 8 Z" fill="#E74C3C" stroke="none" />
                    <path d="M -12 0 A 12 12 0 0 1 -8.5 -8.5 L -6 -6 A 8 8 0 0 0 -8 0 Z" fill="#E74C3C" stroke="none" />
                </g>
            </defs>
            <rect width="800" height="400" fill="url(#oceanGradient)" />
            <g className="wave-layers">
                <path d="M0,350 Q100,340 200,350 T400,350 T600,350 T800,350 L800,400 L0,400 Z" fill="#ffffff" opacity="0.1">
                    <animateTransform attributeName="transform" type="translate" values="0,0; -200,0; 0,0" dur="8s" repeatCount="indefinite" />
                </path>
                <path d="M0,360 Q150,350 300,360 T600,360 T900,360 L900,400 L0,400 Z" fill="#ffffff" opacity="0.08">
                    <animateTransform attributeName="transform" type="translate" values="0,0; 150,0; 0,0" dur="12s" repeatCount="indefinite" />
                </path>
            </g>
            {/* PERBAIKAN: Gunakan komponen Tugboat yang baru */}
            <g className="sailing-ships">
                <Tugboat scale="0.25" duration="25s" pathValues="-100,50; 900,70; -100,50" />
                <Tugboat scale="0.2" duration="30s" pathValues="850,150; -150,180; 850,150" />
                <Tugboat scale="0.15" duration="22s" pathValues="-100,250; 900,240; -100,250" />
            </g>
            
            <text x="400" y="40" textAnchor="middle" fontSize="24" fontWeight="bold" fill="#ffffff" opacity="0.9" stroke="#1976d2" strokeWidth="1">
                LANCANG KUNING NUSANTARA
            </text>
        </svg>
    );
}

export default KalselMapSVG;